import {DocTypeQuery} from "../models/DocTypeQuery";
import { BaseDataService } from "../../../services/base/BaseDataService";
import { DocType } from "../models/DocType";


export class DocTypeService extends BaseDataService<DocType, DocTypeQuery> {
  protected prefixUrl = `doctypes`;
}